module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9fd052aaf1b4701ff0134d124d6327a3.jpg";